import { TeamService } from '../services/team.service';
import { PortalBootstrapService } from '../services/portal-bootstrap.service';
import * as i0 from "@angular/core";
import * as i1 from "../services/team.service";
import * as i2 from "../services/portal-bootstrap.service";
export class TeamTemplateResolver {
    constructor(teamService, portalBootstrap) {
        this.teamService = teamService;
        this.portalBootstrap = portalBootstrap;
    }
    resolve(route, state) {
        const routeParameter = route.paramMap.get('team');
        const result = this.teamService.getTeamInfoByTemplateName(routeParameter);
        // Apply this portal's Auth0 settings (synchronous) before the auth page activates, so
        // AuthPageComponent.ngOnInit can decide whether to redirect to Auth0. Needed for the
        // start-at-root flow, where the team isn't in the URL when the APP_INITIALIZER runs.
        this.portalBootstrap.loadForTeam(routeParameter);
        return result;
    }
}
TeamTemplateResolver.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TeamTemplateResolver_Factory() { return new TeamTemplateResolver(i0.ɵɵinject(i1.TeamService), i0.ɵɵinject(i2.PortalBootstrapService)); }, token: TeamTemplateResolver, providedIn: "root" });
